import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminBooks() {
  return (
    <AdminCrud
      title="Livros"
      resource="books"
      initialItem={{ format: "Impresso", status: "published" }}
      statusOptions={[
        { value: "published", label: "Publicado" },
        { value: "coming_soon", label: "Em Breve" },
        { value: "hidden", label: "Oculto" },
        { value: "under_construction", label: "Em construção" },
      ]}
      fields={[
        { name: "title", label: "Título", required: true },
        { name: "subtitle", label: "Subtítulo" },
        { name: "slug", label: "Slug (URL)", required: true, help: "Ex: o-canto-do-boto" },
        {
          name: "author_id",
          label: "Autor",
          type: "resource_select",
          resource: "authors",
          labelField: "name",
          valueField: "id",
          linkedFields: { author_name: "name" },
          help: "Selecione um autor cadastrado. O livro aparecerá automaticamente na página do autor.",
        },
        { name: "author_name", label: "Nome do autor (auto-preenchido)", help: "Preenchido ao escolher o autor acima. Sobrescreva apenas se necessário." },
        { name: "cover_url", label: "Capa do livro", type: "image" },
        { name: "synopsis", label: "Sinopse", textarea: true, rows: 5 },
        { name: "isbn", label: "ISBN" },
        { name: "pages", label: "Páginas", type: "number" },
        { name: "category", label: "Categoria" },
        { name: "genre", label: "Gênero" },
        { name: "format", label: "Formato" },
        { name: "year", label: "Ano", type: "number" },
        { name: "price", label: "Preço" },
        { name: "buy_link", label: "Link Comprar (URL externa)", help: "Amazon, Mercado Livre, Hotmart, site do autor…" },
        { name: "featured", label: "Destaque", type: "checkbox", help: "Aparece na home" },
        { name: "new_release", label: "Lançamento", type: "checkbox" },
        { name: "bestseller", label: "Mais vendido", type: "checkbox" },
      ]}
      columns={[
        { name: "title", label: "Título" },
        { name: "author_name", label: "Autor" },
        { name: "category", label: "Categoria" },
        { name: "year", label: "Ano" },
      ]}
    />
  );
}
